import {
  collection,
  documentId,
  getDocs,
  query,
  Timestamp,
  where,
} from 'firebase/firestore';
import { setData } from '../../project';
import { firestoreOutFlax } from '../../functions/firebase/firebase';

type Tprops = {
  pass: {
    ipt1: any[];
    ipt2: string;
    ipt3: any[];
  };
  args?: any;
};

export type TMergedLocalBikes = {
  createdAt: Timestamp;
  docId: string;

  modelAmount: string;
  modelName: string;
  modelPrice: string;

  imgUrl: string;
  modelCode: string;
  modelId: string;
  status: 'available' | 'unavailable';

  localBikeId: string;
  localBikeAmount: number;
  allLocalIds: string[];
};

type TModelBikes = {
  createdAt: Timestamp;
  docId: string;
  imgUrl: string;
  modelAmount: string;
  modelName: string;
  modelPrice: string;
};

type TLocalBikes = {
  createdAt: Timestamp;
  docId: string;
  imgUrl: string;
  modelCode: string;
  modelId: string;
  status: 'available' | 'unavailable';
};

// ------------------ Objetivo é buscar e mostrar Dados das Bikes
// ------------------ filtrados por Ponto (loja).

// --------------------------------------------------------------
// ---------------------- MERGE DATA DE -------------------------
// --------------------------------------------------------------
// ------------------ /locations/ID/localBikes ------------------
// ------------------ com os dados de ---------------------------
// ------------------ /bikeModels -------------------------------

export const mergeLocationBikes = async (props: Tprops) => {
  const { ipt1, ipt2 } = props.pass;

  // ---------- set Local Imports
  const path1 = ipt1?.join() ?? '';

  // const fbInit = getCtData('all.fireInit');
  const localBikes: TLocalBikes[] = props?.args[0]; // collection 'localBikes' (código, quantidade etc)
  const arrIDsModels = localBikes.map(i => i?.modelId) ?? [];

  console.log('local Bikes (curr location selected)', props.args);
  console.log({ arrIDsModels });
  if (arrIDsModels.length > 0) {
    // Bike Models (Foto, Preço p/ Hora)
    const ref = collection(firestoreOutFlax, ipt2);
    const q = query(ref, where(documentId(), 'in', arrIDsModels));
    const snapshot = await getDocs(q);

    const bikeModels = snapshot.docs.map(doc => ({
      docId: doc.id,
      ...doc.data(),
    }));

    const condPath1 = path1.includes('A10'); // sc.A10.currData.bikesList
    const condPath2 = path1.includes('B3B'); // sc.B3B.currData.mainList
    console.log({ bikeModels });

    const isArray = Array.isArray(bikeModels);
    const newArray = [];
    if (isArray) {
      // --- WHEN SCREEN IS A10 (DESKTOP)
      if (condPath1) {
        for (const key in localBikes) {
          const item = localBikes[key];
          const fnFindItem: any = i => i?.docId === item?.modelId;
          const foundModelDetails = bikeModels.find(fnFindItem);

          if (foundModelDetails) {
            item.localBikeId = item?.docId;
            item.imgUrl = foundModelDetails?.imgUrl;
            item.modelAmount = foundModelDetails?.modelAmount;
            item.modelName = foundModelDetails?.modelName;
            item.modelPrice = foundModelDetails?.modelPrice;

            // ---- MODEL AVAILABILITY
            item.status = item?.status;
          }

          newArray.push(item);
        }
      }

      // --- WHEN SCREEN IS B3B (MOBILE)
      if (condPath2) {
        for (const key in bikeModels) {
          const item: TMergedLocalBikes = bikeModels[key];
          const fnFindItem: any = i => i?.modelId === item.docId;

          // -------------------------------
          // ----- Filtra Apenas Disponíveis
          // -------------------------------
          const fnFilterItems: any = i => {
            const check = i?.modelId === item.docId;
            const check2 = i?.status === 'available';

            return check && check2;
          };

          const countLocalBikeAmount = localBikes.filter(fnFilterItems).length; // Número Total LocalBikes Disponíveis
          const foundLocalBike = localBikes.find(fnFindItem); // ItemFound / Match Id CurrItem Loop

          // ---- ---- ---- ----
          // ---- ---- ---- ----
          // ---- ---- ---- ----
          const arrIDsLocalBikes =
            localBikes
              .filter(
                i =>
                  i?.docId &&
                  i?.status === 'available' &&
                  i?.modelId === item.docId,
              )
              .map(i => i.docId) ?? [];

          if (foundLocalBike) {
            item.localBikeId = foundLocalBike?.docId;
            item.localBikeAmount = countLocalBikeAmount;
            item.modelCode = foundLocalBike?.modelCode;
            item.modelId = foundLocalBike?.modelId;
            item.allLocalIds = arrIDsLocalBikes;

            // ---- CHECK MODEL AVAILABILITY
            if (countLocalBikeAmount < 1) item.status = 'unavailable';
            if (countLocalBikeAmount > 0) item.status = 'available';
          }

          newArray.push(item);
        }
      }

      console.log({ path1 });
      console.log({ newArray });
      setData({ path: path1, value: newArray });
    }
  }
};
